var map = {
	"./avatar-1.png": 304,
	"./avatar-10.png": 305,
	"./avatar-2.png": 306,
	"./avatar-3.png": 307,
	"./avatar-4.png": 308,
	"./avatar-5.png": 309,
	"./avatar-6.png": 310,
	"./avatar-7.png": 311,
	"./avatar-8.png": 312,
	"./avatar-9.png": 313
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;



//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars ^\.\/avatar\-.*\.png$
// module id = 30
// module chunks = 1